const searchFiles = (searchTerm, directories, extension = '') => {
    return new Promise((resolve, reject) => {
        ApiClient.post(
            'files/search',
            { limit: 100, offset: '' },
            { filters: { search: searchTerm, directories: directories, extension } },
        )
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export { searchFiles };
